function updateTimer(remainingTime, timerDigits) {
  const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / 60000);
  const seconds = Math.floor((remainingTime % 60000) / 1000);

  const timeString = `${days.toString().padStart(2, '0')}${hours.toString().padStart(2, '0')}${minutes.toString().padStart(2, '0')}${seconds.toString().padStart(2, '0')}`;

  timerDigits.forEach((digitGroup, groupIndex) => {
    const digits = timeString.slice(groupIndex * 2, groupIndex * 2 + 2);
    digitGroup[0].textContent = digits[0];
    digitGroup[1].textContent = digits[1];
  });
}

function startTimer(targetDate) {
  const timer = document.querySelector('.timer');
  if (!timer) {
    console.error('Timer element not found');
    return;
  }

  const timerDigits = Array.from(timer.querySelectorAll('.timer__digit')).map(digitGroup => digitGroup.querySelectorAll('.timer__digit-number'));

  let timerInterval;

  function tick() {
    const now = new Date().getTime();
    const remainingTime = targetDate - now;

    if (remainingTime <= 0) {
      clearInterval(timerInterval);
      return;
    }

    updateTimer(remainingTime, timerDigits);
  }

  tick();
  timerInterval = setInterval(tick, 1000);
}

function parseDateString(dateString) {
  const [datePart, timePart] = dateString.split(' ');
  const [day, month, year] = datePart.split('.').map(Number);
  const [hours, minutes] = timePart.split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes).getTime();
}

export { startTimer, parseDateString };